import type { JSX } from 'react';
import { useTranslation } from 'react-i18next';
import { useLibellesModules } from '../../lib/modules.js';
import type { VueDAigle } from '../../types.js';
import commun from './commun.module.css';
import { Section } from './composants.js';
import { useFormats } from './formats.js';
import { ListeBarres } from './ListeBarres.js';

/**
 * L'adoption des modules complémentaires : combien de galeries en exploitation
 * (production, essai et sans contrat) en ont activé chacun. Le dénominateur de
 * la note est celui des scores (`sur`), jamais le seul compte « en production ». Des comptes, jamais le nom d'une galerie.
 */
export function Modules({ vue, numero }: { vue: VueDAigle; numero: string }): JSX.Element {
  const { t } = useTranslation('console');
  const f = useFormats();
  const libelles = useLibellesModules();

  const lignes = [...vue.modules]
    .sort((a, b) => b.galeries - a.galeries)
    .map((ligne) => ({
      cle: ligne.module,
      libelle: libelles.libelle(ligne.module),
      score: t('vueDAigle.modules.score', { galeries: ligne.galeries, sur: ligne.sur }),
      detail: ligne.sur > 0 ? f.pourcent(ligne.galeries / ligne.sur) : undefined,
      ratio: ligne.sur > 0 ? ligne.galeries / ligne.sur : 0,
    }));

  return (
    <Section
      id="modules"
      numero={numero}
      titre={t('vueDAigle.modules.titre')}
      note={t('vueDAigle.modules.note', { count: vue.modules[0]?.sur ?? 0 })}
    >
      {lignes.length === 0 ? (
        <p className={commun.noteDiscrete}>{t('vueDAigle.modules.vide')}</p>
      ) : (
        <ListeBarres lignes={lignes} />
      )}
    </Section>
  );
}
